var exports = {
  "kL": "InboxPopout.module__container___T1Zadm",
  "QZ": "InboxPopout.module__containerWithSidebar___T1Zadm",
  "pz": "InboxPopout.module__sidebar___T1Zadm",
  "G9": "InboxPopout.module__sidebarTabList___T1Zadm",
  "NP": "InboxPopout.module__sidebarFooterActions___T1Zadm",
  "jR": "InboxPopout.module__sidebarActionButton___T1Zadm",
  "M6": "InboxPopout.module__mainPanel___T1Zadm",
  "yt": "InboxPopout.module__sidebarTab___T1Zadm",
  "yR": "InboxPopout.module__tabActive___T1Zadm",
  "DF": "InboxPopout.module__tabInactive___T1Zadm",
  "Qs": "InboxPopout.module__content___T1Zadm",
  "Lj": "InboxPopout.module__tabContent___T1Zadm",
  "Bx": "InboxPopout.module__iconSmall___T1Zadm",
};

module.exports = exports;
